export default "__VITE_ASSET__aacc3e47__"